
import { combineReducers } from '@reduxjs/toolkit';
import paymentSlice from './paymentSlice';
import subscriptionSlice from './subscriptionSlice';
import serverSlice from './serverSlice';
import plansSlice from './plansSlice';
import pageSlice from './pageSlice';
import consentsSlice from './consentsSlice';
import candidateSlice from './candidateSlice';
import experimentSlice from './experimentSlice';

export default combineReducers({
  payment: paymentSlice,
  subscription: subscriptionSlice,
  server: serverSlice,
  plans: plansSlice,
  page: pageSlice,
  consents: consentsSlice,
  candidate: candidateSlice,
  experiment: experimentSlice,
});
